<template>
  <div>
    <input type="file" @change="onFileChange"/>
    <button @click="upload">上传</button>
  </div>
</template>

<script>
import axios from 'axios'; // 添加这一行来导入axios

export default {
  data() {
    return {
      selectedFile: null,
      targetDirectory: 'uploads/'
    };
  },
  methods: {
    onFileChange(e) {
      this.selectedFile = e.target.files[0];
    },
    upload() {
      if (!this.selectedFile) {
        alert('请选择一个文件');
        return;
      }

      // 获取上传凭证
      this.getUploadToken().then(data => {
        // 生成新的文件名（例如：添加时间戳）
        const newFileName = `${new Date().getTime()}-${this.selectedFile.name}`;
        // 构建目标文件的键（包括目录）
        const date = new Date();
        const year = date.getFullYear();
        let month = (date.getMonth() + 1).toString().padStart(2, '0'); // 月份是从0开始的，所以+1
        let day = date.getDate().toString().padStart(2, '0');
        const key = `${this.targetDirectory}${year}${month}${day}/${newFileName}`;
        const observable = qiniu.upload(this.selectedFile, key, data.uptoken);

        observable.subscribe({
          next(res){
            // 处理上传进度等信息
            console.log('上传进度:', res.total.percent);
          },
          error(err){
            // 处理错误
            console.error('上传失败:', err);
          },
          complete(res){
            // 文件上传成功后的处理
            console.log('上传完成:', res);
            alert('上传成功！');
          }
        });
      }).catch(error => {
        console.error('获取上传凭证失败:', error);
      });
    },
    async getUploadToken() {
      try {
        const response = await axios.post('/common/getUptoken');
        return response.data;
      } catch (error) {
        console.error('请求过程中出现问题:', error);
        throw error; // 抛出错误以便.catch()可以捕获
      }
    }
  }
};
</script>
